<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
    },
    data() {
        return {
            title: "Branch Block Date",
            items: [
                {
                    text: "Branch Block Date"
                },
            ],
            fields: [
                { key: "action" },
                { key: 'branch_id', sortable: true, label: 'Branch' },
                { key: "date", sortable: true, label: 'From Date' },
                { key: "to_date", sortable: false, label: 'To Date' },
                { key: 'start', sortable: true, label: 'Start Time' },
                { key: 'end', sortable: true, label: 'End Time' },
                { key: 'full_day_leave', sortable: true, label: 'Full Day Leave' },
            ]
        };
    },
    computed: {

    },
    watch: {

    },
    async mounted() {
        //
    },
    methods: {
        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/block/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete block date (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            this.$refs.listingTable.filterTable('', '');
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2 ml-1">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Branch Block Date Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Block Date</router-link>
                        </div>
                    </div>
                    <div class="pl-4 pr-4">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="block" listName="branchblocks">
                            <template v-slot:cell(start)="{ item }">
                                {{ item.start ?? '-' }}
                            </template>
                            <template v-slot:cell(end)="{ item }">
                                {{ item.end ?? '-' }}
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Branch Block Date Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>